import { NativeModules, Platform } from 'react-native';

export const iCloudStorage =
  Platform.OS === 'ios' ? NativeModules.iCloudStorage : null;
